module.exports = __webpack_public_path__ + "static/media/roman-pro.2ecdd304.jpg";